import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

let btns = document.getElementsByClassName('gsap-hero-btns');

gsap.to(".gsap-hero-bg", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gsap-hero-trigger",
        start: 'top bottom',
        endTrigger: '.gsap-hero-trigger',
        end: 'bottom center',
        markers: false,
        scrub: true,
    },
    y: '6rem',
});

gsap.from(".gsap-hero-content", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gsap-hero-content",
        start: 'bottom bottom',
        end: 'bottom +=40%',
        markers: false,
        scrub: true,
    },
    opacity: 0,
});

if(btns.length){
    gsap.from(btns, {
        scrollTrigger: {
            toggleActions: "play none reverse none",
            trigger: btns,
            start: 'bottom bottom',
            end: 'top +=100%',
            markers: false,
            scrub: true,
        },
        opacity: 0,
    });
}
